module.exports = __webpack_public_path__ + "assets/img/no-data.e780f8c2.png";